import '../../styles/Welcome.css';

export function Welcome({ welcome }) {
  const flowers = `img/${welcome.img[0]}`;
  const soccer = `img/${welcome.img[1]}`;
  const law = `img/${welcome.img[2]}`;
  const girl = `img/${welcome.img[3]}`; 

  return(
    <>
      <section className="hero is-medium is-primary component-container">
        <div className="hero-body mb-0 pb-0">
          <div className="columns is-desktop">
            
            <div className="column">
              <h3 className='subtitle is-3 bf-sub-title'>{welcome.title}</h3>
              <p className='card-content is-size-5 '>{welcome.text}</p>
            </div>

            <div className="column">
              <div className="img-welcome-container">
                <img className='img-welcome'
                  style={{top:"-30px", left:"10%", zIndex:0, transform:"rotate(-10deg)"}}
                  src={flowers}
                  alt="flowers"
                />

                <img className='img-welcome'
                  style={{top:"20px", left:"25%", zIndex:1, transform:"rotate(7deg)"}}
                  src={soccer}
                  alt="soccer"
                />

                <img className='img-welcome'
                  style={{top:"10px", left:"45%", zIndex:2, transform:"rotate(-17deg)"}}
                  src={law}
                  alt="law"
                />

                <img className='img-welcome'
                  style={{top:"-18px", left:"60%", zIndex:3, transform:"rotate(9deg)"}}
                  src={girl}
                  alt="girl"
                />

              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}